import React from 'react'

import { SubTitleDescriptionCTAImageType } from '@application/Types/ComponentTypes'
import { Carousel } from '@organisms/Carousel'

import { ItemWrapper, TitleSection } from './SubTitleDescriptionCTAImage.styled'
import { SubTitleDescriptionCTAImageItem } from './SubTitleDescriptionCTAImageItem/SubTitleDescriptionCTAImageItem'

export const SubTitleDescriptionCTAImage = (props: SubTitleDescriptionCTAImageType): JSX.Element => {
    const { subTitleDescriptionCTAImageTitle, subtitle, screenshots, mode } = props

    return (
        <TitleSection title={subTitleDescriptionCTAImageTitle} subtitle={subtitle} mode={mode}>
            <Carousel desktopColumn>
                {screenshots.map((item, i) => (
                    <ItemWrapper key={`${i}-${item.title}`}>
                        <SubTitleDescriptionCTAImageItem item={item} mode={mode} />
                    </ItemWrapper>
                ))}
            </Carousel>
        </TitleSection>
    )
}
